import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

import { PaymentFormValues } from 'components/Dialogs/Finance/PaymentDialog/PaymentSchema';

export interface Payment extends PaymentFormValues {
  id: string;
}

export type UpdatePaymentResult = Payment | null;
export type UpdatePaymentParams = PaymentFormValues;

async function updatePayment(params: UpdatePaymentParams): Promise<UpdatePaymentResult> {
  // ensure payment has an id
  if (!params?.id) {
    throw new Error('Payment id is required');
  }

  // make api call
  const result = await privateApi.put(`${import.meta.env.VITE_API_BASE_URL}/finance/payments/${params.id}`, params);

  // return the data object
  return result.data as Payment | null;
}

const useUpdatePayment = createMutation<UpdatePaymentResult, UpdatePaymentParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables: UpdatePaymentParams) => updatePayment(variables),
});

export { updatePayment as UpdatePayment, useUpdatePayment };
